import generateStore from './generateStore.js'

// #467 — runs of the Minga sheet import (admin only; 404 in other orgs).
export default (app) => generateStore('sheet_sync/runs', app)
